import styled from 'styled-components';

export const PngDiv = styled.div`
  position: relative;
  z-index: 1;

  @media (min-width: 375px) {
  }
  @media (min-width: 768px) {
  }
`;

export const OutletDiv = styled.div`
  position: relative;
  z-index: 9;

  @media (min-width: 375px) {
  }
  @media (min-width: 768px) {
  }
`;
